"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function HomeQuoteModel(
	MODULE_INFO,
	userInputRepository,
	serviceResponseRepository,
	quoteOptions,
	quoteRequestRepository,
	Util,
	$rootScope
) {
	var self = this;

	var selectedQuote = quoteOptions.getSelectedQuoteResult();
	var selectedQuoteForPayment = quoteOptions.getSelectedQuoteResultForPayment();
	var selectedOffering = quoteOptions.getSelectedOffering();

	self.rootScope = $rootScope;

	self.maxSumInsured = 2000000;
	//value will come from quickQuote
	self.minSumInsured = 0;

	/**
	 * Retrieves values from UserInputRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from UserInputRepository to return
	 * @private
	 */
	this._getUserInputValueFor = function(dotSeperatedFieldPath) {
		var userInput = userInputRepository.get();
		return Util.findHierarchyStringInObject(
			userInput,
			dotSeperatedFieldPath,
			"."
		);
	};

	/**
	 * Retrieves values from ServiceResponseRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from ServiceResponseRepository to return
	 * @private
	 */
	this._getServiceResponseValueFor = function(
		serviceName,
		dotSeperatedFieldPath
	) {
		return serviceResponseRepository.getLastResponseFrom(serviceName);
	};

	//retunr the home insurance need type : 'building_only'/'contents_only'/'building_and_contents'
	this.getHomeNeedType = function() {
		if (
			this.homeForm &&
			this.homeForm.tellUsHowWeCanInsureYou &&
			this.homeForm.tellUsHowWeCanInsureYou.coverNeeds
		) {
			var building =
				this.homeForm.tellUsHowWeCanInsureYou.coverNeeds.building ==
				true;
			var content =
				this.homeForm.tellUsHowWeCanInsureYou.coverNeeds.contents ==
				true;
		} else {
			return null;
		}

		if (building && content) {
			return "building_and_contents";
		} else if (building && !content) {
			return "building_only";
		} else if (!building && content) {
			return "contents_only";
		} else {
			return null;
		}
	};

	this.getAge = function(dateString) {
		if (dateString) {
			return moment().diff(moment(dateString, "DD/MM/YYYY"), "years");
		} else {
			return 0;
		}
	};

	this.homeHowIsHomeOccupied = function() {
		if (
			this.homeForm &&
			this.homeForm.tellUsAboutTheProperty &&
			this.homeForm.tellUsAboutTheProperty.howIsHomeOccupied
		) {
			return this.homeForm.tellUsAboutTheProperty.howIsHomeOccupied;
		} else {
			return null;
		}
	};

	this.showIsBuiltToCycloneStandards = function(cycloneParams) {
		if (cycloneParams[0] == "19801989") {
			var cycloneRating = isNaN(cycloneParams[1]) ? 0 : cycloneParams[1];
			var address = this._getServiceResponseValueFor("addressSearch");
			if (address && address.enrichment && address.addressLine1) {
				if (address.enrichment.floodRisk.building) {
					var cycloneRiskSeverity = parseInt(
						address.enrichment.cycloneRisk.building
					);
					if (cycloneRiskSeverity >= cycloneRating) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			}
		} else {
			return false;
		}
	};

	/*
	 * Returns the list of avialble offerings based on the user selections
	 */
	this.getOfferings = function() {
		// this._getUserInputValueFor('formData.homeForm.tellUsAboutTheProperty.howIsHomeOccupied');
		var homeOccupancy;
		var buildingType;
		var needs;

		if (this.homeForm && this.homeForm.tellUsAboutTheProperty) {
			homeOccupancy = this.homeForm.tellUsAboutTheProperty
				.howIsHomeOccupied;
			buildingType = this.homeForm.tellUsAboutTheProperty.typeOfBuilding;
			needs = this.homeForm.tellUsHowWeCanInsureYou.coverNeeds;
		} else {
			console.error(
				"Not able to find the data for calculating permutations"
			);
		}

		var offerings = _getOfferings(homeOccupancy, buildingType, needs, true);

		return offerings;
	};

	//getOfferings is based on the exisitng portal
	function _getOfferings(
		homeOccupancy,
		buildingType,
		needs,
		needRapidEstimate
	) {
		//logic from exsting portal
		var offerings = [];
		if (
			(homeOccupancy === "own_live" ||
				homeOccupancy === "rent_live" ||
				homeOccupancy === "own_holidayhome") &&
			!(
				buildingType === "unit" ||
				buildingType === "flat" ||
				buildingType === "villa" ||
				buildingType === "townhouse"
			)
		) {
			offerings.push("QPHStandardOffering");
			if (needRapidEstimate) {
				offerings.push("QPHPrestigeOffering");
			}
		} else if (
			(homeOccupancy === "own_live" ||
				homeOccupancy === "rent_live" ||
				homeOccupancy === "own_holidayhome") &&
			(buildingType === "unit" ||
				buildingType === "flat" ||
				buildingType === "villa" ||
				buildingType === "townhouse") &&
			needs.building
		) {
			offerings.push("QPHStandardOffering");
			if (needRapidEstimate) {
				offerings.push("QPHPrestigeOffering");
			}
		} else if (
			(homeOccupancy === "own_live" ||
				homeOccupancy === "rent_live" ||
				homeOccupancy === "own_holidayhome") &&
			(buildingType === "unit" ||
				buildingType === "flat" ||
				buildingType === "villa" ||
				buildingType === "townhouse") &&
			needs.contents
		) {
			offerings.push("QPHStrataContentsOffering");
			if (needRapidEstimate) {
				offerings.push("QPHPrestigeOffering");
			}
		} else if (
			homeOccupancy === "own_rent_tenants" ||
			homeOccupancy === "own_rent_tenants_causalbasis" ||
			homeOccupancy === "property_used_hostel_or_guest"
		) {
			offerings.push("QPHLandlordOffering");
		}
		return offerings;
	}

	this.getSelectedOffering = function() {
		return selectedOffering;
	};

	this.address = {};

	this.getCycleData = function() {
		if (this.homeForm && this.homeForm.cycleCover) {
			return this.homeForm.cycleCover;
		}
		return null;
	};

	this.isByCompany = function() {
		if (this.homeForm && this.homeForm.letsGetStarted) {
			return this.homeForm.letsGetStarted.personOrCompany == "company";
		}

		return false;
	};

	this.getinsuranceHistoryYear = function(insuranceHeldFor) {
		var insuranceHeldForMapping = {
			noPreviousInsurance: "0",
			lessThan1year: "1",
			oneYear: "1",
			twoYears: "2",
			threeYears: "3",
			fourOrMoreYears: "4"
		};
		if (insuranceHeldForMapping[insuranceHeldFor]) {
			return insuranceHeldForMapping[insuranceHeldFor];
		} else {
			return "1";
		}
	};

	this.isRapidEstimatePanelVisible = function() {
		var address = this._getServiceResponseValueFor("addressSearch");
		var display = false;
		if (address && address.enrichment && address.addressLine1) {
			//address is available
			if (isLowRisk(address.enrichment)) {
				display = true;
			} else {
				// console.log('--------------------------- no rapid estimate based on enrichment');
				display = false;
			}
		}
		return display;
	};

	this.isBuildingFloodSafe = function() {
		var address = this._getServiceResponseValueFor("addressSearch");
		if (address && address.enrichment && address.addressLine1) {
			if (address.enrichment.floodRisk.building) {
				var floodRiskSeverity = parseInt(
					address.enrichment.floodRisk.building
				);
				if (floodRiskSeverity > 1) {
					return false;
				} else {
					//safe for 0 and 1
					return true;
				}
			} else {
				return false;
			}
		}
	};

	this.isInFloodZone = function() {
		var address = this._getServiceResponseValueFor("addressSearch");
		if (address && address.enrichment && address.addressLine1) {
			var risk = address.enrichment;
			//check flood risk
			var floodRiskSeverity = Math.max(
				parseInt(risk.floodRisk.building),
				parseInt(risk.floodRisk.content)
			);
			// var floodZoneAccuracy = risk.floodRisk.building.substr(2);
			if (floodRiskSeverity > 1) {
				return true;
			}
		}
		return false;
	};

	this.isSumInsuredInLowerRange = function(sumInsured) {
		return (
			sumInsured <= self.minSumInsured * 1.75 &&
			sumInsured >= self.minSumInsured
		);
	};

	this.isSumInsuredInUpperRange = function(sumInsured) {
		return sumInsured > this.cordelInfo.upperBand;
	};

	function isLowRisk(risk) {
		//check cyclone risk
		var cycloneRiskSeverity = Math.max(
			parseInt(risk.cycloneRisk.building),
			parseInt(risk.cycloneRisk.content)
		);
		if (cycloneRiskSeverity > 1) {
			return false;
		}

		//check flood risk
		var floodRiskSeverity = Math.max(
			parseInt(risk.floodRisk.building),
			parseInt(risk.floodRisk.content)
		);
		if (floodRiskSeverity > 59) {
			return false;
		}

		var floodZoneAccuracy = risk.floodRisk.building.substr(2);
		if (floodZoneAccuracy == "A" || floodZoneAccuracy == "B") {
			//is in zone
		} else {
			return false;
		}

		//check fire risk
		var fireRiskSeverity = Math.max(
			parseInt(risk.fireRisk.building),
			parseInt(risk.fireRisk.content)
		);
		if (fireRiskSeverity > 59) {
			return false;
		}

		var fireZoneAccuracy = risk.fireRisk.building.substr(2);
		if (fireZoneAccuracy == "A" || fireZoneAccuracy == "B") {
			//is in zone
		} else {
			return false;
		}

		return true;
	}

	this.email = this._getUserInputValueFor(
		"homeForm.tellUsABitMore.yourEmailAddress"
	)
		? this._getUserInputValueFor("homeForm.tellUsABitMore.yourEmailAddress")
		: this._getUserInputValueFor("email");

	// home form data
	this.homeForm = this._getUserInputValueFor("homeForm");

	// cover type
	this.selectedQuote = selectedQuote;
	this.selectedQuoteForPayment = selectedQuoteForPayment;
	this.dwelling = null;
	//  this._getServiceResponseValueFor('quickQuote');
	if (selectedQuote) {
		this.annualCoverType = selectedQuote.getAnnual();
		this.monthlyCoverType = selectedQuote.getMonthly();
		// this.fortnightlyCoverType = selectedQuote.getMonthly();

		this.quoteResult = this.selectedQuoteForPayment; // selectedQuote.getQuoteResult();
		if (this.quoteResult) {
			this.cordelInfo = this.quoteResult.cordelInfo;
			self.minSumInsured = Math.round(this.cordelInfo.lowerBand * 0.75);

			this.excess = this.quoteResult.excess;
			this.dwelling = this.quoteResult;
			this.offering = this.quoteResult.offering;
		}
	}

	this.postCode = null;
	this.campaignCode = null;

	if (this.homeForm) {
		// address
		var aboutYourHome = this.homeForm.tellUsAboutTheProperty;
		if (aboutYourHome && aboutYourHome.address) {
			this.address = aboutYourHome.address;
			this.postCode = this.address.postalCode;
			this.state = this.address.state;
		}

		if (this.homeForm.promotionalCode) {
			this.campaignCode = this.homeForm.promotionalCode.promotionalCode;
		}

		if (this.homeForm.letsGetStarted) {
			this.policyContactType = this.homeForm.letsGetStarted.personOrCompany;
			this.policyStartDate = this.homeForm.letsGetStarted.startCoverDate;

			if (
				this.policyContactType == "person" &&
				this.homeForm.mainPolicyHolder
			)
				this.policyContact = this.homeForm.mainPolicyHolder;
			else if (
				this.policyContactType == "contact" &&
				this.homeForm.aboutCompanyContact
			)
				this.policyContact = this.this.homeForm.aboutCompanyContact;
		}
	}

	// this.quoteId = this._getServiceResponseValueFor('service-name', 'quote.quoteId');
	this.quoteId = null;
	if (quoteRequestRepository.getSelectedQuoteCredentials())
		this.quoteId = quoteRequestRepository.getSelectedQuoteCredentials().quoteID;

	/** Google Tag Manager data **/
	this.gtmPolicyHolder = this.policyContact;
	this.gtmTransactionAffiliation = "QBE Direct";
	this.insuranceType = MODULE_INFO.insuranceType;
	this.productCode = MODULE_INFO.productCode;
}
